import { motion } from "framer-motion";
import { useContent } from "@/context/ContentContext";
import { resolveImage, renderLinkedText } from "@/lib/content";
import { scrollTo } from "@/components/Navbar";

export const HowItWorks = () => {
  const { content } = useContent();
  const how = content.how;
  return (
  <section
    id="how-it-works"
    className="mx-auto max-w-7xl px-6 py-28 lg:px-10 lg:py-40"
    data-testid="how-it-works-section"
  >
    <div className="grid items-start gap-16 lg:grid-cols-12">
      <div className="lg:col-span-6">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-100px" }}
          transition={{ duration: 0.9, ease: [0.22, 1, 0.36, 1] }}
        >
          <p className="mb-6 text-[11px] font-bold uppercase tracking-[0.3em] text-[#7A2B21]">
            {how.kicker}
          </p>
          <h2 className="font-display text-4xl font-medium leading-[1.1] tracking-tight text-[#1C1917] sm:text-5xl">
            {how.title_line1}{" "}
            <span className="italic text-[#7A2B21]">{how.title_line2}</span>
          </h2>
          <div className="arch-frame mt-12 overflow-hidden shadow-[0_30px_60px_rgba(28,25,23,0.15)]">
            <motion.img
              src={resolveImage(how.image)}
              alt={content.how.image_alt || "Tricity Family Concierge property visit region — Chandigarh, Mohali and Panchkula"}
              data-testid="how-it-works-image"
              className="hero-image-grade h-[420px] w-full object-cover"
              initial={{ scale: 1.1 }}
              whileInView={{ scale: 1 }}
              viewport={{ once: true }}
              transition={{ duration: 1.6, ease: [0.22, 1, 0.36, 1] }}
            />
          </div>
        </motion.div>
      </div>

      <div className="lg:col-span-6">
        {how.steps.map((s, i) => (
          <motion.div
            key={s.num}
            initial={{ opacity: 0, x: 40 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true, margin: "-60px" }}
            transition={{ duration: 0.8, delay: i * 0.1, ease: [0.22, 1, 0.36, 1] }}
            className="group flex gap-6 border-b border-[#1C1917]/10 py-8 last:border-b-0"
            data-testid={`how-step-${s.num}`}
          >
            <span className="flex h-12 w-12 shrink-0 items-center justify-center rounded-full border border-[#7A2B21]/30 font-display text-lg italic text-[#7A2B21] transition-colors duration-500 group-hover:bg-[#7A2B21] group-hover:text-[#FAF8F5]">
              {s.num}
            </span>
            <div>
              <h3 className="font-display text-xl font-medium tracking-tight text-[#1C1917] md:text-2xl">
                {renderLinkedText(s.title)}
              </h3>
              <p className="mt-2 max-w-md text-sm leading-relaxed text-[#57534E]">
                {renderLinkedText(s.body)}
              </p>
            </div>
          </motion.div>
        ))}
        <motion.button
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.8, delay: 0.4 }}
          onClick={() => scrollTo("#enquire")}
          data-testid="how-it-works-cta"
          className="mt-10 rounded-full bg-[#2C4C3B] px-8 py-4 text-sm font-bold uppercase tracking-wider text-[#FAF8F5] transition-[background-color,transform] duration-300 hover:bg-[#1f3529] hover:scale-[1.03] active:scale-[0.98]"
        >
          {how.cta_label}
        </motion.button>
      </div>
    </div>
  </section>
  );
};
